import React from 'react';
import { blue } from '@ant-design/colors';
import { PhoneOutlined } from '@ant-design/icons';
import { getTelHref } from '../utils';

interface Props {
	phone: string | null;
}

export const PhoneLink: React.FC<Props> = ({ phone }) => {
	if (!phone) {
		return <>-</>;
	}

	return (
		<a href={getTelHref(phone)} style={{ color: blue[4] }} onClick={(e) => e.stopPropagation()}>
			{phone} <PhoneOutlined />
		</a>
	);
};
